import type { AuthorQuoteSlice } from "~/api/prismic/types"
import CustomRichText from "~/components/CustomRichText"
import TailwindProseWrapper from "~/components/TailwindProseWrapper"
import { asText } from "~/utils/prismic/richText"

export type AuthorQuoteProps = {
  slice: AuthorQuoteSlice
}

export const AuthorQuote: React.FC<AuthorQuoteProps> = ({ slice }) => {
  const { quote, author_name: author } = slice.primary

  return (
    <TailwindProseWrapper>
      <blockquote className="bg-gray-100 dark:bg-primary-700">
        <div className="py-px">
          <CustomRichText field={quote} />
        </div>

        <footer className="flex items-center pb-5 text-xs not-italic md:text-sm lg:text-base">
          &ndash; {asText(author)}
        </footer>
      </blockquote>
    </TailwindProseWrapper>
  )
}
